import { createContext, useContext } from 'react';

import { DeleteEntityContext } from './delete-entity-controller';

export const ModalContext = createContext({
  isOpen: false,
  onOpen: () => {},
  onClose: () => {},
});

function useModalController() {
  const { publicId, type, entityName, onDeleteSuccess } = useContext(DeleteEntityContext);
  const { isOpen, onClose, onOpen } = useContext(ModalContext);

  return {
    isOpen,
    onOpen,
    onClose,
    publicId,
    type,
    entityName,
    onDeleteSuccess,
  };
}

export default useModalController;
